import { UPSMyChoiceIndexPageInstaller } from 'components/dashboard/integrations/services/UPSMyChoice/UPSMyChoiceIndexPageInstaller'

export const IntegrationModalIds = {
    UPS_MY_CHOICE_INSTALLED: 'UPS_MY_CHOICE_INSTALLED',
}

export const IntegrationModals = {
    [IntegrationModalIds.UPS_MY_CHOICE_INSTALLED]: UPSMyChoiceIndexPageInstaller,
}
